<h1 mat-dialog-title>Replace Billcode</h1>

<mat-dialog-content class="!flex flex-col items-center justify-stretch gap-4">
  <div>
    Replace <strong>{{ initial }}</strong> with:
  </div>
  <div>
    <mat-form-field>
      <mat-label>{{ current }}</mat-label>
      <mat-select [(ngModel)]="current">
        @for (option of selectOptions; track option) {
          <mat-option [value]="option?.value">
            {{ option?.description }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)="shouldSave(false)">Cancel</button>
  <button mat-raised-button color="primary" (click)="shouldSave(true)">Replace Billcode</button>
</mat-dialog-actions>
